import axios from 'axios';
import * as Sentry from '@sentry/browser';
import {
  AUTH_USER,
  AUTH_ERROR,
  UNAUTH_USER,
  TWO_FACTOR,
  TWO_FACTOR_ERROR,
} from '../types';
import { API_URL } from '../../environment';
import { headers } from '../defaults';

export function signinUser(
  values,
  callback = () => {},
  errorCallBack = () => {},
) {
  return dispatch => {
    axios
      .post(`${API_URL}/practice/sessions/login`, values)
      .then(response => {
        if (response.data.two_factor_id) {
          dispatch({ type: TWO_FACTOR, payload: response.data });
        } else {
          localStorage.setItem('token', response.data.access_token);
          localStorage.setItem(
            'name',
            `${response.data.first_name} ${response.data.last_name}`,
          );
          localStorage.setItem('email', response.data.email);
          localStorage.setItem('created_at', response.data.sign_up_date);
          localStorage.setItem('last_action_at', Date.now());
          dispatch({ type: AUTH_USER });
        }
        callback(response);
      })
      .catch(error => {
        errorCallBack();
        dispatch({ type: AUTH_ERROR, payload: error.response.data.error });
      });
  };
}

export function signoutUser() {
  return dispatch => {
    axios
      .delete(`${API_URL}/practice/sessions/logout`, headers())
      // Logout is best-effort: clear client state regardless of the request
      // outcome, and swallow the rejection so a failed logout doesn't surface
      // as an unhandled promise rejection.
      .catch(() => {})
      .finally(() => {
        localStorage.removeItem('token');
        localStorage.removeItem('email');
        localStorage.removeItem('name');
        localStorage.removeItem('created_at');
        localStorage.removeItem('last_action_at');
        Sentry.configureScope(scope => {
          scope.setUser(null);
        });
        dispatch({ type: UNAUTH_USER });
      });
  };
}

export function forgotPassword(values, callback = () => {}) {
  return dispatch => {
    axios
      .post(`${API_URL}/practice/password_resets`, values)
      .then(response => {
        callback(response.data.status);
        dispatch({ type: 'RESET_PASSWORD_SUCCESS' });
      })
      .catch(error => {
        dispatch({
          type: 'RESET_PASSWORD_ERROR',
          payload: error.response?.data?.message || 'Something went wrong',
        });
      });
  };
}

export function verifyTwoFactor(values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/practice/two_factor_auths/${values.id}`, values)
      .then(response => {
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem(
          'name',
          `${response.data.first_name} ${response.data.last_name}`,
        );
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('created_at', response.data.sign_up_date);
        dispatch({ type: AUTH_USER });
        callback(response);
      })
      .catch(error => {
        dispatch({
          type: TWO_FACTOR_ERROR,
          payload: error.response.data.error,
        });
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function getPin(values, callback = () => {}) {
  return dispatch => {
    axios
      .post(`${API_URL}/practice/two_factor_auths/pin`, values)
      .then(response => {
        dispatch({ type: TWO_FACTOR, payload: response.data });
        callback(response);
      })
      .catch(error => {
        dispatch({
          type: TWO_FACTOR_ERROR,
          payload: error.response.data.error,
        });
        if (error && error.response && error.response.status === 401) {
          dispatch({ type: UNAUTH_USER });
        }
      });
  };
}

export function resetPassword(values, callback = () => {}) {
  return dispatch => {
    axios
      .put(`${API_URL}/practice/passwords/me`, values)
      .then(response => {
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem(
          'name',
          `${response.data.first_name} ${response.data.last_name}`,
        );
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('created_at', response.data.sign_up_date);
        dispatch({ type: AUTH_USER });
        callback(response.data);
      })
      .catch(error => {
        callback(null, error);
      });
  };
}

export const confirmUser =
  (values, callback = () => {}, errorCallback = () => {}) =>
  dispatch => {
    axios
      .put(`${API_URL}/signup`, values)
      .then(response => {
        localStorage.setItem('token', response.data.access_token);
        localStorage.setItem(
          'name',
          `${response.data.first_name} ${response.data.last_name}`,
        );
        localStorage.setItem('email', response.data.email);
        localStorage.setItem('created_at', response.data.sign_up_date);
        localStorage.setItem('locale', response.data.locale);
        dispatch({ type: AUTH_USER });
        callback();
      })
      .catch(error => {
        dispatch({ type: AUTH_ERROR, payload: error.response });
        errorCallback(error);
      });
  };
